import script from "./ipShopping.vue?vue&type=script&setup=true&lang=js"
export * from "./ipShopping.vue?vue&type=script&setup=true&lang=js"

import "./ipShopping.vue?vue&type=style&index=0&id=87fc2e8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87fc2e8e"]])

export default __exports__